import Image from 'next/legacy/image'
import { type Session } from 'next-auth'

import { theme } from '@/ui/theme/theme'

import { Avatar, AvatarImageContainer } from './styled'

export const defaultColorIndex = 3
export const avatarColorsList = [
  theme.colors.blue.light4,
  theme.colors.violet.light4,
  theme.colors.yellow.light4,
  theme.colors.purple.light4,
  theme.colors.red.light4,
]

export type SessionAvatarProps = {
  /** A user's session */
  userSession?: Session['user']
}

export const SessionAvatar = ({ userSession }: SessionAvatarProps) => {
  const id = userSession?.sub && parseInt(userSession.sub, 10)
  const colorIndex = id ? id % avatarColorsList.length : defaultColorIndex
  const _color = avatarColorsList[colorIndex]

  const children =
    userSession && userSession.image ? (
      <AvatarImageContainer>
        <Image data-testid="session-avatar-img" src={userSession.image} alt="" layout="fill" />
      </AvatarImageContainer>
    ) : (
      ((userSession?.name && userSession.name[0]) || 'K').toUpperCase()
    )

  return (
    <Avatar data-testid="session-fsbo-avatar" color={_color}>
      {children}
    </Avatar>
  )
}
